import React from "react";
import { H3 } from "@irati/ui/src/Typography";
import { injectIntl } from "@irati/utils/lang";
import Selector from "@irati/ui/src/Selector";
import { CategoryWrapper, SelectorWrapper } from "./styled";
var CustomisationCategory = function (_a) {
    var category = _a.category, toggleSelection = _a.toggleSelection, selection = _a.selection, formatMessage = _a.formatMessage;
    var name = category.name, _b = category.tags, tags = _b === void 0 ? [] : _b, uuid = category.uuid;
    var activeTags = tags.filter(function (_a) {
        var filterable = _a.filterable;
        return filterable === true;
    });
    var categoryHasTags = activeTags && activeTags.length > 0;
    return (React.createElement(CategoryWrapper, null,
        React.createElement(H3, null, name),
        React.createElement(SelectorWrapper, null,
            categoryHasTags &&
                activeTags.map(function (tag) { return (React.createElement(Selector, { key: tag.uuid, name: tag.name, uuid: tag.uuid, onClick: toggleSelection, selected: selection.includes(tag.uuid) })); }),
            !categoryHasTags && (React.createElement(Selector, { key: uuid, name: formatMessage({
                    id: "account.customisation.interests.allLabel"
                }, {
                    name: name
                }), uuid: uuid, onClick: toggleSelection, selected: selection.includes(uuid) })))));
};
export default injectIntl(CustomisationCategory);
